module.exports = {
  messages: {
    BUTTON_BACK: 'Back',
    COMMUNICATION_ERROR_500_SUBLINE:
      "We're brewing up a fix right now. Thanks for your patience.",
    COMMUNICATION_ERROR_500_TITLE:
      'Looks like our system is taking a coffee break',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Find jobs',
    LOSP_SWIMP_COMPANY_LABEL: 'At which company and in which city?',
    LOSP_SWIMP_COMPANY_PLACEHOLDER: 'e.g. REWE Group in Cologne',
    LOSP_SWIMP_CONTINUE_BUTTON: 'Continue',
    LOSP_SWIMP_ERROR_BUTTON_PROMPT: 'Try again',
    LOSP_SWIMP_ERROR_BUTTON_SYSTEM: 'Retry',
    LOSP_SWIMP_ERROR_TEXT_PROMPT:
      'Please enter a job title and the company you work for. A location would be great as well.',
    LOSP_SWIMP_ERROR_TITLE_PROMPT: 'Help us out',
    LOSP_SWIMP_LOADING_SUBTITLE: 'and fetching matching jobs for you.',
    LOSP_SWIMP_LOADING_TITLE: 'The XING AI is creating your profile',
    LOSP_SWIMP_ROLE_LABEL: 'What do you do for work right now?',
    LOSP_SWIMP_ROLE_PLACEHOLDER:
      'e.g. I’m an account manager with top Excel skills',
    LOSP_SWIMP_SUBTITLE: 'Create a jobseeker profile now with XING AI:',
    LOSP_SWIMP_TITLE_B: 'Click, click',
    LOSP_SWIMP_TITLE_C: 'Instant Match',
  },
};
